import { render, staticRenderFns } from "./ResellerPaymentForm.vue?vue&type=template&id=1d8c4d1b"
import script from "./ResellerPaymentForm.vue?vue&type=script&lang=js"
export * from "./ResellerPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports